import angular from 'angular';

let LeaguesFactory = angular.module('LeaguesFactory', [])
.factory('LeaguesFactory', ($rootScope, $http, HttpFactory, URLS) => {
	'ngInject';
	const LEAGUE_TYPES = {
		RECURVE: "recurve",
		COMPOUND: "compound",
		FIELD: "field",
	};
	return {
		LEAGUE_TYPES: LEAGUE_TYPES,
		getAll: (params) => {
			let parameters = Object.assign({}, params);
			return HttpFactory.get(URLS.LEAGUES, parameters);
		},
		getOne: (leagueId) => {
			let url = URLS.LEAGUES + "/" + leagueId;
			return HttpFactory.get(url);
		},
		create: (data) => {
			return HttpFactory.post(URLS.LEAGUES, data);
		},
		update: (leagueId, data) => {
			let url = URLS.LEAGUES + "/" + leagueId;
			return HttpFactory.put(url, data);
		},
		delete: (leagueId) => {
			let url = URLS.LEAGUES + "/" + leagueId;
			return HttpFactory.delete(url);
		}
	};
}).name;

export default LeaguesFactory;



// WEBPACK FOOTER //
// ./client/app/services/leagues.factory.js